/* Arc.tsx generated by @compiled/babel-plugin v0.28.8 */
import "./Arc.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import { arc as d3Arc } from 'd3-shape';
import { element } from '../../core/elements';
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function setNumberOrNumberAccessor(func, value) {
  if (typeof value === 'number') func(value);else func(value);
}
const arcStyles = `opacity .3s`;
export function arc(_temp) {
  let {
    innerRadius,
    outerRadius,
    cornerRadius,
    startAngle,
    endAngle,
    padAngle,
    padRadius
  } = _temp === void 0 ? {} : _temp;
  const path = d3Arc();
  if (innerRadius != null) setNumberOrNumberAccessor(path.innerRadius, innerRadius);
  if (outerRadius != null) setNumberOrNumberAccessor(path.outerRadius, outerRadius);
  if (cornerRadius != null) setNumberOrNumberAccessor(path.cornerRadius, cornerRadius);
  if (startAngle != null) setNumberOrNumberAccessor(path.startAngle, startAngle);
  if (endAngle != null) setNumberOrNumberAccessor(path.endAngle, endAngle);
  if (padAngle != null) setNumberOrNumberAccessor(path.padAngle, padAngle);
  if (padRadius != null) setNumberOrNumberAccessor(path.padRadius, padRadius);
  return path;
}
function Arc(_ref) {
  let {
    innerRadius,
    outerRadius,
    cornerRadius,
    startAngle,
    endAngle,
    padAngle,
    padRadius,
    datum,
    opacity,
    children,
    innerRef,
    ariaLabel,
    fill,
    stroke,
    transition = arcStyles,
    ...rest
  } = _ref;
  const path = arc({
    innerRadius,
    outerRadius,
    cornerRadius,
    startAngle,
    endAngle,
    padAngle,
    padRadius
  });
  if (children) return /*#__PURE__*/_jsx(_Fragment, {
    children: children({
      path
    })
  });
  if (!datum && (startAngle == null || endAngle == null || innerRadius == null || outerRadius == null)) {
    console.warn('[@visx/shape/Arc]: expected data because one of startAngle, endAngle, innerRadius, outerRadius is undefined. Bailing.');
    return null;
  }
  return /*#__PURE__*/_jsx("path", {
    ref: innerRef,
    d: path(datum) || '',
    role: "img",
    "aria-label": ariaLabel,
    opacity: opacity,
    fill: fill,
    stroke: stroke,
    ...rest,
    className: ax(["_v5641dtu"]),
    style: {
      "--_178jgwx": ix(transition)
    }
  });
}
const _Arc = element(Arc);
export { _Arc as Arc };